import { render, staticRenderFns } from "./FooterLayout.vue?vue&type=template&id=d61c6936&scoped=true&lang=pug&"
import script from "./FooterLayout.vue?vue&type=script&lang=js&"
export * from "./FooterLayout.vue?vue&type=script&lang=js&"
import style0 from "./FooterLayout.vue?vue&type=style&index=0&id=d61c6936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61c6936",
  null
  
)

export default component.exports